export default function () {
  // https://inclusive-components.design/collapsible-sections/
  const accordions: NodeList | null = document.querySelectorAll(".accordion");

  if (accordions) {
    // Get all the <h2> headings
    accordions.forEach((accordion: Node): void => {
      const _accordion = accordion as HTMLElement;
      const headings: NodeList | null = _accordion.querySelectorAll(
        ".accordion__headline"
      );
      // console.log('heading', headings);

      Array.prototype.forEach.call(headings, (heading) => {
        const aria_controls_id = heading.getAttribute("data-id");

        // Give each <h2> a toggle button child
        // with the SVG plus/minus icon
        heading.innerHTML = `
						<button aria-expanded="false" aria-controls="${aria_controls_id}">
							<span>${heading.textContent}</span>
								<svg width="22" height="22" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
									<!-- Horizontal line -->
									<line x1="20" y1="50" x2="80" y2="50" stroke="black" stroke-width="6"/>
									<!-- Vertical line -->
									<line x1="50" y1="20" x2="50" y2="80" stroke="black" stroke-width="6"/>
								</svg>
						</button>
					`;

        // Function to create a node list
        // of the content between this <h2> and the next
        const getContent = (elem: HTMLElement): HTMLElement[] => {
          const elems: HTMLElement[] = [];
          let nextSibling = elem.nextElementSibling as HTMLElement | null;
          while (
            nextSibling &&
            nextSibling.tagName !== "H2" &&
            nextSibling.tagName !== "H3"
          ) {
            elems.push(nextSibling);
            elem = nextSibling;
            nextSibling = elem.nextElementSibling as HTMLElement | null;
          }

          // Delete the old versions of the content nodes
          elems.forEach((node) => {
            if (node.parentNode) {
              node.parentNode.removeChild(node);
            }
          });

          return elems;
        };

        // Assign the contents to be expanded/collapsed (array)
        const contents = getContent(heading as HTMLElement);

        // Create a wrapper element for `contents` and hide it
        const wrapper = document.createElement("div");
        wrapper.hidden = true;

        // Add each element of `contents` to `wrapper`
        contents.forEach((node) => {
          wrapper.appendChild(node);
        });

        // Add the wrapped content back into the DOM
        // after the heading
        if (heading.parentNode) {
          heading.parentNode.insertBefore(wrapper, heading.nextElementSibling);
        }

        // Assign the button
        const btn = heading.querySelector("button") as HTMLButtonElement;

        if (btn && aria_controls_id && window.location.hash === `#${aria_controls_id}`) {
          expand(btn, wrapper, aria_controls_id);
        }

        if (btn) {
          btn.onclick = () => {
            expand(btn, wrapper, aria_controls_id || undefined);
          };
        }
      });
    });
  }

  function expand(btn: HTMLButtonElement, wrapper: HTMLElement, aria_controls_id?: string) {
    // Cast the state as a boolean
    const expanded = btn.getAttribute("aria-expanded") === "true";

    // Switch the state
    btn.setAttribute("aria-expanded", String(!expanded));
    // Switch the content's visibility
    wrapper.hidden = expanded;

    // if (!expanded && aria_controls_id) {
    //   window.location.hash = aria_controls_id;
    // } else {
    //   window.location.hash = "";
    // }
  }
}
